import { render, staticRenderFns } from "./SectionFeatures.vue?vue&type=template&id=087ff297&scoped=true&"
import script from "./SectionFeatures.vue?vue&type=script&lang=js&"
export * from "./SectionFeatures.vue?vue&type=script&lang=js&"
import style0 from "./SectionFeatures.vue?vue&type=style&index=0&id=087ff297&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087ff297",
  null
  
)

export default component.exports